var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeLinejoin: "round",
    "data-testid": "geist-icon",
    style: {
      color: "currentcolor"
    },
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.47 1.47a4.285 4.285 0 1 1 6.06 6.06l-2.5 2.5-1.06-1.06 2.5-2.5a2.786 2.786 0 0 0-3.94-3.94l-2.5 2.5-1.06-1.06zm3.06 4.06-6 6-1.06-1.06 6-6zm-10.06 9a4.285 4.285 0 0 0 6.06 0l2.5-2.5-1.06-1.06-2.5 2.5a2.786 2.786 0 0 1-3.94-3.94l2.5-2.5-1.06-1.06-2.5 2.5a4.285 4.285 0 0 0 0 6.06",
    clipRule: "evenodd"
  })));
};
export default SvgLink;